import React, { FC, useState } from 'react';
import { AddBlockButtonProps } from '../../../types';
import AddBlockButtonLarge from './AddBlockButtonLarge';
import { Icons } from '../../../../shared/components';
import AddBlockButton from './AddBlockButton';
import { useTranslation } from 'react-i18next';
import { Dialog } from '@material-ui/core';
import { ExerciseFormContent } from '../../SeriesDetail/ExerciseForm';
import { BlockType } from '../../../../../config/api/models/Block';
import { useAppDispatch } from 'src/modules/shared/hooks/useAppDispatch';
import { addBlock, addBlockType } from 'src/modules/shared/slices/blocks/api/blocks';
import { defaultExerciseFormInitialValues } from '../../SeriesDetail/ExerciseForm/ExerciseFormContent';

const AddExerciseBlockButton: FC<AddBlockButtonProps> = ({
  bookId,
  pageId,
  viewMode,
  previousBlockId,
  clusterId,
  sectionId,
}) => {
  const { t } = useTranslation();
  const [dialogOpen, setDialogOpen] = useState(false);
  const dispatch = useAppDispatch();

  return (
    <>
      {
        {
          emptyPage: (
            <AddBlockButtonLarge
              title={t(`trajectory.page.blocks.h5p.title`)}
              description={t(`trajectory.page.blocks.h5p.description`)}
              icon={Icons.BLOCK_TYPE_EXERCISE}
              onClick={() => setDialogOpen(true)}
            />
          ),
          sidebar: <AddBlockButton type={BlockType.H5P} onClick={() => setDialogOpen(true)} />,
        }[viewMode]
      }
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        aria-labelledby={'add-iframe-form'}
        fullWidth
      >
        <ExerciseFormContent
          mode="dialog"
          onSubmit={(values: addBlockType['payload']) => {
            dispatch(
              addBlock({
                bookId,
                pageId,
                payload: {
                  title: values.title,
                  level: values.level,
                  bloom_type: values.bloom_type,
                  type: values.type,
                  algebra_kit_exercise_id: values.algebra_kit_exercise_id,
                  previous_block_id: sectionId === previousBlockId ? '' : previousBlockId,
                  exercise_tool: values.exercise_tool === '1' ? null : values.exercise_tool,
                  cluster_id: clusterId,
                  section_id: sectionId,
                  description: values.description ? values.description : '',
                },
              })
            );
            setDialogOpen(false);
          }}
          onCancel={() => setDialogOpen(false)}
          initialValues={defaultExerciseFormInitialValues}
        />
      </Dialog>
    </>
  );
};

export default AddExerciseBlockButton;
